/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory, Redirect } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector, useDispatch } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import SVG from "react-inlinesvg";
import { baseUrl, config } from "../../../../../services/config";

export function UserProfileDropdown() {
  const dispatch = useDispatch();
  // const { user } = useSelector((state) => state.user);
  let user;
  if (localStorage.getItem("userDetails")) {
    user = JSON.parse(localStorage.getItem("userDetails"));
  }

  const [updateData, setUpdateData] = useState([]);
  const authtoken = localStorage.getItem("userToken");
  // console.log('header user',user.roles[0])
  const history = useHistory();
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(updateData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = updateData.slice(startIndex, startIndex + itemsPerPage);

  useEffect(() => {
    getSettingData();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        getNewUpdates(data.payload.settings.head_office_url);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getNewUpdates = async (branchUrl) => {
    await fetch(`${branchUrl}/updates`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setUpdateData(data.payload.reverse());
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };
  const logout = () => {
    dispatch({
      type: "ADD_USER",
      payload: {
        isAuthenticated: false,
        user: null,
        authtoken: null,
      },
    });
    localStorage.clear();
    history.push("/auth/login");
  };
  return (
    <>
      <Dropdown drop="down" alignRight>
        <Dropdown.Toggle
          as={DropdownTopbarItemToggler}
          id="dropdown-toggle-user-profile"
        >
          <div
            className={
              "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 drop_down_button_div"
            }
          >
            <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
              New Updates
            </span>

            <a
              style={{
                backgroundColor: `${config.btnColor}`,
                padding: "18px",
                position: "relative",
              }}
              className="btn btn-icon btn-sm mx-3"
            >
              {updateData.length > 0 && (
                <span
                  className="badge bg-danger"
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    fontSize: "10px",
                    padding: "3px 6px",
                    borderRadius: "50%",
                  }}
                >
                  {updateData?.length}
                </span>
              )}
              <span
                style={{ padding: "10px" }}
                className="svg-icon svg-icon-md logouticone_span"
              >
                <div className="navi-icon m-2 position-relative">
                  <i className="flaticon2-notification" />
                </div>
              </span>
            </a>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
          <>
            {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
            {layoutProps.light && (
              <>
                <div className="d-flex align-items-center p-8 rounded-top">
                  <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                    <img
                      src={toAbsoluteUrl("/media/users/300_21.jpg")}
                      alt=""
                    />
                  </div>
                  <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
                    New Updates
                  </div>
                </div>
                <div className="separator separator-solid"></div>
              </>
            )}

            {!layoutProps.light && (
              <div
                className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
                style={{
                  backgroundColor: `${config.btnColor}`,
                }}
              >
                <div
                  style={{ backgroundColor: `${config.btnColor}` }}
                  className="text-white m-0 flex-grow-1 mr-3 font-size-h5"
                >
                  New Updates
                </div>
              </div>
            )}
          </>

          <>
            {paginatedData.length === 0 ? (
              <div className="d-flex align-items-start m-5 p-3 mb-2 rounded shadow-sm bg-white border">
                <div className="navi-text flex-grow-1">
                  <div className="text-dark cursor-pointer text-center">
                    No New Updates Found
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center px-3 mt-3">
                  <button
                    className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    disabled={currentPage === 1}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Navigation/Angle-left.svg"
                        )}
                      />
                    </span>
                  </button>
                  <span className="text-dark">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={currentPage === totalPages || totalPages === 0}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Navigation/Angle-right.svg"
                        )}
                      />
                    </span>
                  </button>
                </div>

                <div className="row m-5">
                  {paginatedData.map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-start p-3 mb-2 rounded shadow-sm bg-white border"
                    >
                      <div className="navi-icon mr-3 mt-1">
                        <i className="flaticon2-notification text-color-primary fs-3" />
                      </div>
                      <div className="navi-text flex-grow-1">
                        <div className="fw-bold text-dark mb-1 cursor-pointer">
                          {item?.title}
                        </div>
                        <div className="text-dark">{item?.description}</div>
                        {/* Optional Timestamp */}
                        {item?.created_at && (
                          <div className="small text-color-primary mt-1">
                            {new Date(item.created_at).toLocaleString("en-US", {
                              dateStyle: "medium",
                              timeStyle: "short",
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown drop="down" alignRight>
        <Dropdown.Toggle
          as={DropdownTopbarItemToggler}
          id="dropdown-toggle-user-profile"
        >
          {/* 
        <a
          style={{ backgroundColor: "#121291", padding: "18px" }}
          className="btn btn-icon  
      
          btn-sm mx-3"

        >
          <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {user.roles[0]}
          </span>

          <span style={{ padding: "10px" }} className="svg-icon svg-icon-md logouticone_span">
            <SVG style={{ margin: "10px" }} className="logouticone"
              src={toAbsoluteUrl("/media/svg/icons/Navigation/Sign-out.svg")}
            />
          </span>
        </a> */}

          <div
            className={
              "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 drop_down_button_div"
            }
          >
            <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
              {user?.office_title || user?.roles[0].name}
              {/* {user.user.first_name} {user.user.last_name} */}
            </span>

            <a
              style={{ backgroundColor: `${config.btnColor}`, padding: "18px" }}
              className="btn btn-icon  
      
          btn-sm mx-3"
            >
              <span
                style={{ padding: "10px" }}
                className="svg-icon svg-icon-md logouticone_span"
              >
                <SVG
                  style={{ margin: "10px" }}
                  className="logouticone"
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Navigation/Sign-out.svg"
                  )}
                />
              </span>
            </a>

            {/* <span className="logout_icone">
            <SVG className=""

              src={toAbsoluteUrl("/media/svg/icons/Navigation/Sign-out.svg")}
            />
          </span> */}
            {/* <span style={{ padding: "10px" }} className="svg-icon svg-icon-md logouticone_span">
            <SVG style={{ margin: "10px" }} className="logouticone"
              src={toAbsoluteUrl("/media/svg/icons/Navigation/Sign-out.svg")}
            />
          </span> */}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
          <>
            {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
            {layoutProps.light && (
              <>
                <div className="d-flex align-items-center p-8 rounded-top">
                  <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                    <img
                      src={toAbsoluteUrl("/media/users/300_21.jpg")}
                      alt=""
                    />
                  </div>
                  <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
                    {/* {user.roles[0]} */}

                    {/* {user.firstname} {user.lastname} */}
                  </div>
                  {/* <span className="label label-light-success label-lg font-weight-bold label-inline">
                  3 messages
                </span> */}
                </div>
                <div className="separator separator-solid"></div>
              </>
            )}

            {!layoutProps.light && (
              <div
                className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
                style={{
                  backgroundColor: `${config.btnColor}`,
                  // backgroundImage: `url(${toAbsoluteUrl(
                  //   "/media/misc/bg-1.jpg"
                  // )})`,
                }}
              >
                {/* <div className="symbol bg-white-o-15 mr-3">
                <span className="symbol-label text-success font-weight-bold font-size-h4">
                  {user.firstname[0]}
                </span>
                <img alt="Pic" className="hidden" src={user.pic} />
              </div> */}
                <div
                  style={{ backgroundColor: `${config.btnColor}` }}
                  className="text-white m-0 flex-grow-1 mr-3 font-size-h5"
                >
                  {"  "}
                  {user?.office_title || "User"}
                  {/* {user.firs_tname} {user.last_name} */}
                </div>
                {/* <span className="label label-success label-lg font-weight-bold label-inline">
                3 messages
              </span> */}
              </div>
            )}
          </>

          <div className="navi navi-spacer-x-0 pt-5">
            {/* <Link to="/user-profile" className="navi-item px-8 cursor-pointer">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-calendar-3 text-success" />
              </div>
              <div className="navi-text">
                <div className="font-weight-bold cursor-pointer">
                  My Profile
                </div>
                <div className="text-muted">
                  Account settings and more
                  <span className="label label-light-danger label-inline font-weight-bold">
                    update
                  </span>
                </div>
              </div>
            </div>
          </Link> */}

            {/* <a className="navi-item px-8">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-mail text-warning"></i>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">My Messages</div>
                <div className="text-muted">Inbox and tasks</div>
              </div>
            </div>
          </a>

          <a className="navi-item px-8">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-rocket-1 text-danger"></i>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">My Activities</div>
                <div className="text-muted">Logs and notifications</div>
              </div>
            </div>
          </a> */}

            {/* <a className="navi-item px-8">
            <div className="navi-link">
              <div className="navi-icon mr-2">
                <i className="flaticon2-hourglass text-primary"></i>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">My Tasks</div>
                <div className="text-muted">latest tasks and projects</div>
              </div>
            </div>
          </a> */}
            <div className="navi-separator mt-3"></div>

            <div className="navi-footer  px-8 py-5">
              <button
                onClick={logout}
                className="btn btn-primary font-weight-bold "
              >
                Sign Out
              </button>
              {/* <a href="#" className="btn btn-clean font-weight-bold">
              Upgrade Plan
            </a> */}
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
